import React from "react";
import { Modal, ModalBody } from "reactstrap";
import styles from "./SellerModal.module.scss";

import { useFormik } from "formik";
import * as yup from "yup";
import Textfield from "../../Shared/Textfield";
import Button from "../../Shared/Button";

const AddProductSchema = yup.object().shape({
  Name: yup.string().required("Name is required"),
});

const SellerModal = ({ openModal, toggle, data }) => {
  const initialState = {
    Name: data?.name || "",
    Email: data?.email || "",
    Phone: data?.phone || "",
    Bio: data?.bio || "",
    Role: data?.role || "",
  };
  const formik = useFormik({
    initialValues: initialState,
    validationSchema: AddProductSchema,
    onSubmit: (values) => {
      handleSubmit(values);
    },
  });

  const handleSubmit = async (formData) => {};

  const handleChange = (e) => {
    formik.handleChange(e);
  };

  return (
    <>
      <Modal
        isOpen={openModal}
        toggle={() => {
          toggle();
        }}
        centered
        fullscreen="sm"
        contentClassName={styles["modal_content"]}
        className={styles["step_container"]}
        wrapClassName={styles["modal_wrapper"]}
      >
        <ModalBody className={styles["modal_body"]}>
          <div>
            <p className={styles["heading_container"]}>Seller Details</p>
          </div>

          <div style={{ marginTop: "20px" }}>
            <div className={styles["input_fields_wrapper"]}>
              <Textfield
                value={formik.values.Name}
                error={formik.errors.Name}
                touched={formik.touched.Name}
                handleBlur={formik.handleBlur}
                name="Name"
                id="Name"
                onChange={handleChange}
                type="text"
                placeholder="Name"
                className={styles["input_field_styles"]}
                disabled={true}
              />
            </div>
            <div className={styles["input_fields_wrapper"]}>
              <Textfield
                value={formik.values.Email}
                error={formik.errors.Email}
                touched={formik.touched.Email}
                handleBlur={formik.handleBlur}
                name="Email"
                id="Email"
                onChange={handleChange}
                type="email"
                placeholder="Email"
                className={styles["input_field_styles"]}
                disabled={true}
              />
            </div>

            <div className={styles["input_fields_wrapper"]}>
              <Textfield
                value={formik.values.Bio}
                error={formik.errors.Bio}
                touched={formik.touched.Bio}
                handleBlur={formik.handleBlur}
                name="Bio"
                id="Bio"
                onChange={handleChange}
                type="textarea"
                rows={5}
                placeholder="Bio"
                className={styles["input_field_styles"]}
                style={{
                  height: "150px",
                  resize: "none",
                }}
                disabled={true}
              />
            </div>
            <div className={styles["input_fields_wrapper"]}>
              <Textfield
                value={formik.values.Phone}
                error={formik.errors.Phone}
                touched={formik.touched.Phone}
                handleBlur={formik.handleBlur}
                name="Phone"
                id="Phone"
                onChange={handleChange}
                type="text"
                placeholder="Phone"
                className={styles["input_field_styles"]}
                disabled={true}
              />
              <Textfield
                value={formik.values.Role}
                error={formik.errors.Role}
                touched={formik.touched.Role}
                handleBlur={formik.handleBlur}
                name="Role"
                id="Role"
                onChange={handleChange}
                type="text"
                placeholder="Role"
                className={styles["input_field_styles"]}
                disabled={true}
              />
            </div>
          </div>

          <div className={styles["submit_btns"]}>
            <div className={styles["button_div"]}>
              <Button
                className={styles["button_style_cancel"]}
                onClick={() => {
                  toggle();
                }}
                text="Cancel"
              />
            </div>
            <div className={styles["button_div"]}>
              <Button
                className={styles["button_style_add"]}
                text="Save"
                disabled
              />
            </div>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default SellerModal;
